import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { TravelSheetService } from '../../services/travel-sheet.service';
import { TravelSheetModel } from '../travel-sheet/travel-sheet.model';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-submitted-sheets',
  templateUrl: './submitted-sheets.component.html',
  styleUrls: ['./submitted-sheets.component.css']
})
export class SubmittedSheetsComponent implements OnInit {
  travelSheetModel: TravelSheetModel;
  travelSheetList = [];
  financialList;
  branchList;
  closingDateList;
  roleList;
  selectedFinancialYear;
  selectedBranch;
  selectedRole;
  selectedClosingDate;
  isRoleSelected = false;
  isBranchSelected = false;
  accessResponse: any;

  constructor(private travelSheetService: TravelSheetService, private masterDataService: MasterDataService,
    private modalService: NgbModal, private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedClosingDate = "";
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
    this.masterDataService.getRoles().subscribe((res) => {
      this.roleList = res;
    });
  }

  closingDateDetailList() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('this.closingDateList', this.closingDateList);
          var notClosedobject = {
            id: 0,
            closingDate: "Not Closed"
          }
          this.closingDateList.push(notClosedobject)
          console.log('closing list', res);
        });
    }
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, false);
    this.isRoleSelected = !this.isRoleSelected;
  }
  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  showExportToExcelButton = false;
  onGetAllSubmittedTravelSheetList() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == "" ||
      this.selectedClosingDate == null ||
      this.selectedClosingDate == "" ||
      this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedRole == null ||
      this.selectedRole.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    var branchId = this.selectedBranch.map(({ id }) => id);
    var roleId = this.selectedRole.map(({ id }) => id);

    console.log('branchId,roleID', this.selectedClosingDate);
    this.travelSheetService.getAllSubmittedTravelSheets(branchId, roleId, this.selectedClosingDate).subscribe((resp: any) => {
      console.log('submitted travel sheet', resp);
      this.travelSheetList = resp;
      if (this.travelSheetList.length > 0) {
      this.showExportToExcelButton = true;
    } else {
      this.showExportToExcelButton = false;
    }
    });
  }

  fareDocumentsList;
  openDocumentModal(content, fareDocuments) {
    this.fareDocumentsList = fareDocuments;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  
  ViewTravelSheet(travelsheet, modalContent) {
    console.log('travel sheet details', travelsheet);
    this.travelSheetModel = { ...travelsheet };
    this.openModal(modalContent);
  }

  openModal(modalContent) {
    this.modalService.open(modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  exportToExcelClick() {

    var branchId = this.selectedBranch.map(({ id }) => id);
    var roleId = this.selectedRole.map(({ id }) => id);

    this.travelSheetService.excelExportSubmittedTravelSheets(branchId, roleId, this.selectedClosingDate).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
          var downloadURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = "SubmittedSheets.xlsx";
          link.click();
    });
  }
}
